import React, { useEffect } from 'react';
import { NotificationTypes, SmallNotificationBanner } from '@chegg-ui/notification-banner';
import { PaddingContainer } from '../../../components/common/styled';
import { onCloseNotificationBanner } from '../../../utils/NotificationBannerUtil';
import { NOTIFICATION_BANNER_TESTID } from '../../../constants/dataTestAttributes';
import { GRID_WRAPPER_CONTENT_CLASS } from '../../../components/modules/GridLayout/constants';

/* istanbul ignore next */
var ErrorNotificationBanner = function ErrorNotificationBanner(_ref) {
  var _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? '' : _ref$errorMessage;
  useEffect(function () {
    var _document$getElementB;
    (_document$getElementB = document.getElementById(GRID_WRAPPER_CONTENT_CLASS)) === null || _document$getElementB === void 0 || _document$getElementB.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  return /*#__PURE__*/React.createElement(PaddingContainer, {
    top: 5,
    bottom: 10
  }, /*#__PURE__*/React.createElement(SmallNotificationBanner, {
    id: 'SmallNotificationBanner',
    type: NotificationTypes.Error,
    message: errorMessage,
    onCloseClick: onCloseNotificationBanner,
    "data-test": NOTIFICATION_BANNER_TESTID
  }));
};
export default ErrorNotificationBanner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/internals/ErrorNotificationBanner.js
// module id = 1467
// module chunks = 11